import { render } from "./student-quiz-questions.vue?vue&type=template&id=f4ef55bc"
import script from "./student-quiz-questions.vue?vue&type=script&lang=js"
export * from "./student-quiz-questions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__